export const DRAWER_WIDTH = 240;

export const TEST = 0;
